import {
  useIsDictateDeviceSetupVisible,
  useIsDictateHardwareMicEnabled,
} from '@/app-shell/flags/dictate-flags';
import {
  listenHardwareMicConnected,
  type HardwareMicConnectedPayload,
} from '@/tauri/dictation/api';
import { logger } from '@/utils/logger/logger';
import { useDictaphoneConnectedToast } from '@heidi/dictate';
import { hardwareMicDeviceKey } from '@heidi/dictate/data';
import { sanitizeError } from '@heidi/runtime/logger';

const logListenError = (error: unknown) => {
  logger.warn({
    event_type: 'DICTATION_DICTAPHONE_CONNECTED_TOAST_LISTEN_FAILED',
    details: { error: sanitizeError(error) },
  });
};

/**
 * Headless app-root mount for the dictaphone-connected toast. Lives outside
 * the launch-modal host so pages that opt out of global modals still confirm
 * a plug-in.
 */
export function DictaphoneConnectedToastMount(): null {
  useDictaphoneConnectedToast<HardwareMicConnectedPayload>({
    enabled: useIsDictateHardwareMicEnabled(),
    mappingsActive: useIsDictateDeviceSetupVisible(),
    listen: listenHardwareMicConnected,
    deviceKey: hardwareMicDeviceKey,
    onListenError: logListenError,
  });
  return null;
}
